import type { LevelManifest, LevelPack } from '@color-dots/game';

export interface LoadedLevels {
  manifest: LevelManifest;
  packs: LevelPack[];
  levels: LevelPack['levels'];
}

export async function loadManifest(url: string): Promise<LevelManifest> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to load manifest: ${response.status}`);
  }
  return response.json() as Promise<LevelManifest>;
}

export async function loadLevelPack(url: string): Promise<LevelPack> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to load levels: ${response.status}`);
  }
  return response.json() as Promise<LevelPack>;
}

export async function loadAllLevels(baseUrl = '/data/levels'): Promise<LoadedLevels> {
  const manifest = await loadManifest(`${baseUrl}/manifest.json`);
  const packs = await Promise.all(
    manifest.packs.map((entry) => loadLevelPack(`${baseUrl}/${entry.file}`)),
  );
  const levels = packs.flatMap((pack) => pack.levels);
  return { manifest, packs, levels };
}

export function getLevelById(
  levels: LevelPack['levels'],
  id: string,
): LevelPack['levels'][number] | undefined {
  return levels.find((level) => level.id === id);
}
